// make top bar sticky
const navbar = document.getElementById('jsTopBanner');

if (navbar) {
	if (window.pageYOffset > 110) {
		navbar.classList.add('sticky');
	} 

	window.addEventListener('scroll', () => {  
		if (window.pageYOffset > 110) {
		  navbar.classList.add('sticky');
		} 
		
		if (window.pageYOffset <= 90) {
		  navbar.classList.remove('sticky');
		}
		
	  });
}